<template>
  <section>
    <div>
      <b-modal
        :active="isModalCofirmDeleteCommitment"
        aria-modal
        has-modal-card
        :destroy-on-hide="true"
        aria-role="dialog"
        width="100%"
        :can-cancel="['escape']"
      >
        <template>
          <ConfirmDeleteCommitment
            modal-cancel="true"
            :commitment="commitmentToDelete"
            @close="isModalCofirmDeleteCommitment = false"
            @delete="deletePerformance()"
          />
        </template>
      </b-modal>
    </div>
    <div class="title is-5 has-text-centered">
      Agregar Actividad Académica y Hora al Compromiso
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>
    <ValidationObserver ref="observer" id="form-commitment">
      <div class="columns">
        <div class="column">
          <b-field label="Actividad Académica">
            <template #label>
              Actividad Académica <span style="color: red">*</span>
            </template>
            <ValidationProvider
              name="Actividad Académica"
              rules="required"
              v-slot="{ errors }"
            >
              <multiselect
                v-model="selected_academic_activity"
                :options="academicArea.academic_activities"
                searchable
                :custom-label="(opt) => opt.alt_name"
                placeholder="Seleccione una Actividad"
                selectLabel="Presione para seleccionar"
                selectedLabel="Seleccionado"
                deselectLabel=""
                :allow-empty="false"
              >
                <template v-slot:noOptions> No hay datos. </template>
                <template v-slot:noResult>
                  No se han encontrado resultados para su búsqueda, pruebe con
                  otra.
                </template>
              </multiselect>
              <span class="validation-alert">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-field>
        </div>
        <div v-if="need_subject && mySubjects.length == 0" class="column">
          <h3 class="is-size-6 has-text-weight-bold">
            Asignatura <span style="color: red">*</span>
            <b-tooltip position="is-right" size="is-large" multilined>
              <template v-slot:content>
                Si no encuentra la asignatura en la lista, seleccione
                <strong style="color: white">Otros</strong> e ingrese el nombre
                de la asignatura en el campo
                <strong style="color: white">Observaciones</strong>. La sigla
                <strong style="color: white">S/J</strong> significa 'Sin
                Jornada', es decir, no se especifica en los datos.
              </template>
              <b-icon
                pack="fas"
                icon="info-circle"
                size="is-small"
                type="is-info"
              ></b-icon>
            </b-tooltip>
          </h3>
          <b-field label=" ">
            <ValidationProvider
              name="Asignaturas"
              rules="required"
              v-slot="{ errors }"
            >
              <multiselect
                v-model="selected_subject"
                :options="subjects"
                searchable
                :custom-label="(opt) => opt.codigo_nombre"
                placeholder="Busque y seleccione Asignatura"
                selectLabel="Presione para seleccionar"
                selectedLabel="Seleccionado"
                :allow-empty="false"
                :disabled="disable_subject"
              >
                <template v-slot:noOptions> No hay datos. </template>
                <template v-slot:noResult>
                  No se han encontrado resultados para su búsqueda, pruebe con
                  otra.
                </template>
              </multiselect>
              <span class="validation-alert">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-field>
        </div>

        <div v-if="need_subject && mySubjects.length > 0" class="column">
          <h3 class="is-size-6 has-text-weight-bold">
            Asignatura <span style="color: red">*</span>
            <b-tooltip position="is-right" size="is-large" multilined>
              <template v-slot:content>
                El listado muestra el historico de asignaturas que ha realizado,
                en caso de no encontrar la asignatura, seleccione
                <strong style="color: white">Otros</strong> para desplegar el
                listado general de asignaturas y poder seleccionar la que
                corresponda. La sigla
                <strong style="color: white">S/J</strong> significa 'Sin
                Jornada', es decir, no se especifica en los datos.
              </template>
              <b-icon
                pack="fas"
                icon="info-circle"
                size="is-small"
                type="is-info"
              ></b-icon>
            </b-tooltip>
          </h3>
          <b-field label=" ">
            <ValidationProvider
              name="Asignaturas"
              rules="required"
              v-slot="{ errors }"
            >
              <multiselect
                v-model="selected_subject"
                :options="
                  showAllSubjects ? subjectsWithOthers : mySubjectsWithOthers
                "
                searchable
                :custom-label="(opt) => opt.codigo_nombre"
                placeholder="Busque y seleccione Asignatura"
                selectLabel="Presione para seleccionar"
                selectedLabel="Seleccionado"
                :allow-empty="false"
                :disabled="disable_subject"
                @select="handleSubjectSelection"
              >
                <template v-slot:noOptions> No hay datos. </template>
                <template v-slot:noResult>
                  No se han encontrado resultados para su búsqueda, pruebe con
                  otra.
                </template>
              </multiselect>
              <span class="validation-alert">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-field>
        </div>
        <div
          v-if="need_program_type && academicArea.alt_name === 'Docencia'"
          class="column"
        >
          <h3 class="is-size-6 has-text-weight-bold">
            Tipo de Programa Académico
            <span style="color: red">*</span>
          </h3>
          <b-field label=" ">
            <ValidationProvider
              name="Tipo de Programa Académico"
              rules="required"
              v-slot="{ errors }"
            >
              <multiselect
                v-model="selected_program_type"
                :options="program_types"
                placeholder="Seleccione un tipo de programa"
                selectLabel="Presione para seleccionar"
                selectedLabel="Seleccionado"
                @input="onManualTypeChange()"
                :allow-empty="false"
                :disabled="
                  (academicArea.alt_name === 'Docencia' ||
                    academicArea.alt_name === 'Educación Continua - VIME') &&
                  disabled_docencia_comp
                "
              />
              <span class="validation-alert">{{ errors[0] }}</span>
              <span class="is-size-7 has-text-grey">{{
                autoMessageProgramType
              }}</span>
            </ValidationProvider>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-narrow">
          <b-field label="Seleccione el tipo de hora a comprometerse">
            <br />
            <b-radio-button
              v-model="isWeekly"
              :native-value="true"
              type="is-primary"
              :disabled="
                (academicArea.alt_name === 'Docencia' ||
                  academicArea.alt_name === 'Educación Continua - VIME') &&
                disabled_docencia_comp
              "
            >
              <span>Horas Semanales</span>
            </b-radio-button>
            <b-radio-button
              v-model="isWeekly"
              :native-value="false"
              type="is-primary"
              :disabled="
                (academicArea.alt_name === 'Docencia' ||
                  academicArea.alt_name === 'Educación Continua - VIME') &&
                disabled_docencia_comp
              "
            >
              <span>Horas Semestrales</span>
            </b-radio-button>
          </b-field>
        </div>

        <div class="column">
          <h3 class="is-size-6 has-text-weight-bold">
            Horas que comprometo a realizar 1er Semestre<span style="color: red"
              >*</span
            >
            <b-tooltip
              label="Ingrese 0 si no se realiza en el semestre"
              position="is-right"
              size="is-large"
              multilined
            >
              <b-icon
                pack="fas"
                icon="info-circle"
                size="is-small"
                type="is-info"
              >
              </b-icon>
            </b-tooltip>
          </h3>
          <b-field label=" ">
            <ValidationProvider
              name="Horas que Comprometo a Realizar Primer Semestre"
              :rules="{
                double: 1,
                max: 255,
                min_double: 0,
                required: true,
                onlyOneCanBeZero: hours_committed_semester_2,
              }"
              v-slot="{ errors }"
            >
              <b-input
                v-model="hours_committed_semester_1"
                placeholder="Ej: 5.5 o 1.2"
                :disabled="
                  (academicArea.alt_name === 'Docencia' ||
                    academicArea.alt_name === 'Educación Continua - VIME') &&
                  disabled_docencia_comp
                "
                @input="onManualHourChange('semester_1')"
              />
              <span class="validation-alert">{{ errors[0] }}</span>
              <span class="is-size-7 has-text-grey">{{ autoMessage }}</span>
            </ValidationProvider>
          </b-field>
        </div>

        <div class="column">
          <h3 class="is-size-6 has-text-weight-bold">
            Horas que comprometo a realizar 2do Semestre<span style="color: red"
              >*</span
            >
            <b-tooltip
              label="Ingrese 0 si no se realiza en el semestre"
              position="is-right"
              size="is-large"
              multilined
            >
              <b-icon
                pack="fas"
                icon="info-circle"
                size="is-small"
                type="is-info"
              >
              </b-icon>
            </b-tooltip>
          </h3>
          <b-field label=" ">
            <ValidationProvider
              name="Horas que Comprometo a Realizar Segundo Semestre"
              :rules="{
                double: 1,
                max: 255,
                min_double: 0,
                required: true,
                onlyOneCanBeZero: hours_committed_semester_1,
              }"
              v-slot="{ errors }"
            >
              <b-input
                v-model="hours_committed_semester_2"
                placeholder="Ej: 5.5 o 1.2"
                :disabled="
                  (academicArea.alt_name === 'Docencia' ||
                    academicArea.alt_name === 'Educación Continua - VIME') &&
                  disabled_docencia_comp
                "
                @input="onManualHourChange('semester_2')"
              />
              <span class="validation-alert">{{ errors[0] }}</span>
              <span class="is-size-7 has-text-grey">{{ autoMessage }}</span>
            </ValidationProvider>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field label="Observaciones">
            <ValidationProvider
              name="Observaciones"
              rules="max:500|min:3"
              v-slot="{ errors }"
            >
              <b-input
                v-model="observations"
                placeholder="Ej: Observaciones"
                type="textarea"
                :disabled="
                  (academicArea.alt_name === 'Docencia' ||
                    academicArea.alt_name === 'Educación Continua - VIME') &&
                  disabled_docencia_comp
                "
              />
              <span class="validation-alert">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column has-text-right">
          <b-button
            v-if="commitmentId"
            label="Guardar Edición del Compromiso"
            type="is-warning"
            icon-left="edit"
            @click="checkEdit()"
          />
          <b-button
            v-else
            label="Agregar Actividad al Compromiso"
            type="is-success"
            icon-left="plus"
            @click="checkAdd()"
          />
        </div>
      </div>
    </ValidationObserver>

    <div class="title is-5 has-text-centered">
      Actividades y Horas Comprometidas
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>

    <div class="columns">
      <div class="column has-text-right">
        <b-button
          :label="
            openedDetail.length === 0
              ? 'Expandir Observaciones'
              : 'Contraer Observaciones'
          "
          :icon-left="
            openedDetail.length === 0 ? 'plus-circle' : 'minus-circle'
          "
          type="is-blue-color"
          @click="
            openedDetail.length === 0
              ? (openedDetail = performances)
              : (openedDetail = [])
          "
        />
      </div>
    </div>

    <b-table
      striped
      :data="
        performances.filter((x) => x.alt_name_area === academicArea.alt_name)
      "
      paginated
      per-page="10"
      :pagination-simple="false"
      pagination-position="bottom"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Página"
      aria-current-label="Página actual"
      detail-icon="plus-circle"
      :opened-detailed="openedDetail"
      detailed
    >
      <b-table-column
        field="commitment_index"
        label="N°"
        width="5%"
        v-slot="props"
      >
        {{ props.index + 1 }}
      </b-table-column>
      <b-table-column
        field="alt_name_activity"
        label="Actividad Académica"
        v-slot="props"
      >
        {{ props.row.alt_name_activity }}
      </b-table-column>
      <b-table-column
        field="is_weekly_hours"
        label="Tipo de Hora"
        v-slot="props"
      >
        {{ props.row.is_weekly_hours ? "Semanales" : "Semestrales" }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_1"
        label="Horas 1er Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_1 }}
      </b-table-column>
      <b-table-column
        field="hours_committed_semester_2"
        label="Horas 2do Semestre"
        v-slot="props"
      >
        {{ props.row.hours_committed_semester_2 }}
      </b-table-column>
      <b-table-column
        v-if="
          academicArea.alt_name === 'Docencia' ||
          academicArea.alt_name === 'Educación Continua - VIME'
        "
        field="subject_name"
        label="Asignatura"
        v-slot="props"
      >
        {{
          (function () {
            if (props.row.subject_code == null || props.row.subject_code === "")
              return "";
            const filtered = subjects.filter(
              (subject) => parseInt(props.row.subject_code) === subject.codigo
            );
            return filtered.length > 0 ? filtered[0].codigo_nombre : "";
          })()
        }}
      </b-table-column>
      <b-table-column label="Acciones" width="25%" v-slot="props">
        <b-button
          label="Editar"
          icon-left="edit"
          type="is-warning"
          @click="editPerformance(props.row)"
        />
        <b-button
          icon-left="trash"
          type="is-danger"
          @click="confirmDelete(props.row)"
        />
      </b-table-column>
      <template #detail="props">
        <div class="content">
          <p>
            <b>Observaciones:</b>
            <span class="preserve-line-breaks">{{
              props.row.observations
            }}</span>
          </p>
        </div>
      </template>
      <template slot="empty" slot-scope="props">
        <div class="columns is-centered">
          <div class="column is-6 is-centered has-text-centered">
            <b-message type="is-warning">
              Aún no ha agregado Actividades para
              {{ academicArea.alt_name }}, a medida que agregue se irán
              mostrando en esta tabla.
            </b-message>
          </div>
        </div>
      </template>
    </b-table>
    <b-loading is-full-page v-model="isLoading" />
  </section>
</template>

<script>
import axios from "axios";
import ConfirmDeleteCommitment from "./ConfirmDeleteCommitment.vue";

export default {
  props: {
    academicArea: {
      type: Object,
      required: true,
    },
    performances: {
      type: Array,
      required: true,
    },
    subjects: {
      type: Array,
    },
    mySubjects: {
      type: Array,
    },
  },

  components: {
    ConfirmDeleteCommitment,
  },

  data() {
    return {
      isLoading: false,
      isModalCofirmDeleteCommitment: false,
      commitmentToDelete: null,
      openedDetail: [],
      isEditing: false,

      //Datos a guardar
      selected_academic_activity: null,
      isWeekly: true,
      hours_committed_semester_1: null,
      hours_committed_semester_2: null,
      observations: null,
      commitmentId: null,
      commitment_index: null,
      disabled_docencia_comp: false,
      selected_subject: null,

      need_subject: false,
      disable_subject: true,
      is_edit: false,
      showAllSubjects: false,
      autoMessage: "",
      program_types: ["PREGRADO", "POSTGRADO"],
      need_program_type: false,
      selected_program_type: null,
      autoMessageProgramType: "",
      edit_performance: false,
    };
  },

  created() {},

  methods: {
    async checkAdd() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Algunos campos presentan errores.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      this.$refs.observer.reset();
      this.addCommitment();
    },

    async addCommitment() {
      this.isLoading = true;
      let commitment = {
        hours_committed_semester_1: this.hours_committed_semester_1,
        hours_committed_semester_2: this.hours_committed_semester_2,
        is_weekly_hours: this.isWeekly,
        academic_area_id: this.academicArea.id,
        alt_name_area: this.academicArea.alt_name,
        alt_name_activity: this.selected_academic_activity.alt_name,
        academic_activity_id: this.selected_academic_activity.id,
        observations: this.observations,
        commitment_index: this.commitment_index
          ? this.commitment_index
          : this.performances.length + 1,
        subject_code: this.selected_subject
          ? this.selected_subject.codigo
          : null,
        program_type: this.selected_program_type
          ? this.selected_program_type
          : null,
      };

      await axios
        .post("/performances/add-commitment.json", commitment)
        .then((response) => {
          if (response.data.warning) {
            this.$buefy.dialog.alert({
              title: "Advertencia",
              message: response.data.message,
              type: "is-warning",
              hasIcon: true,
              confirmText: "OK",
            });
          } else {
            commitment.id = response.data.id;
            this.$emit("addCommitment", commitment);

            this.hours_committed_semester_1 = null;
            this.hours_committed_semester_2 = null;
            this.isWeekly = true;
            this.selected_academic_activity = null;
            this.observations = null;
            this.commitment_index = null;
            this.autoMessage = "";
            this.autoMessageProgramType = "";
            this.$buefy.toast.open({
              message: "Se ha Agregado la Actividad al Compromiso",
              type: "is-success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          const errorMsg = error.response.data.errors
            ? error.response.data.errors
            : "Ha ocurrido un error al intentar guardar el compromiso.";
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMsg,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async checkEdit() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Algunos campos presentan errores.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      this.$refs.observer.reset();
      this.editCommitment();
    },

    async editCommitment() {
      this.isLoading = true;
      let commitment = {
        hours_committed_semester_1: this.hours_committed_semester_1,
        hours_committed_semester_2: this.hours_committed_semester_2,
        is_weekly_hours: this.isWeekly,
        academic_area_id: this.academicArea.id,
        alt_name_area: this.academicArea.alt_name,
        alt_name_activity: this.selected_academic_activity.alt_name,
        academic_activity_id: this.selected_academic_activity.id,
        observations: this.observations,
        commitment_index: this.commitment_index
          ? this.commitment_index
          : this.performances.length + 1,
        id: this.commitmentId,
        subject_code: this.selected_subject
          ? this.selected_subject.codigo
          : null,
        program_type: this.selected_program_type
          ? this.selected_program_type
          : null,
      };

      await axios
        .put("/performances/edit-commitment.json", commitment)
        .then((response) => {
          if (response.data.warning) {
            this.$buefy.dialog.alert({
              title: "Advertencia",
              message: response.data.message,
              type: "is-warning",
              hasIcon: true,
              confirmText: "OK",
            });
          } else {
            commitment.id = response.data.id;
            this.$emit("addCommitment", commitment);

            this.hours_committed_semester_1 = null;
            this.hours_committed_semester_2 = null;
            this.isWeekly = true;
            this.selected_subject = null;
            this.selected_academic_activity = null;
            this.observations = null;
            this.commitment_index = null;
            this.commitmentId = null;
            this.disable_subject = true;
            this.disabled_docencia_comp = false;
            this.autoMessage = "";
            this.autoMessageProgramType = "";

            this.$buefy.toast.open({
              message: "Se ha Editado la Actividad del Compromiso",
              type: "is-success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          const errorMsg = error.response.data
            ? error.response.data
            : "Ha ocurrido un error al intentar guardar el compromiso.";
          this.$buefy.dialog.alert({
            title: "Error",
            message: errorMsg,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isEditing = false;
          this.isLoading = false;
        });
    },

    confirmDelete(commitment) {
      this.commitmentToDelete = commitment;
      this.isModalCofirmDeleteCommitment = true;
    },

    async deletePerformance() {
      this.isLoading = true;
      await axios
        .delete(
          `/activity_performances/${this.commitmentToDelete.id}.json`,
          this.commitmentToDelete
        )
        .then((response) => {
          this.$emit("refreshPerfomance", this.commitmentToDelete, true);

          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Se ha eliminado el compromiso de su declaración.",
            type: "is-success",
            hasIcon: true,
            icon: "check-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Ha ocurrido un error al eliminar el compromiso.",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.commitmentToDelete = null;
        });
    },

    async editPerformance(commitment) {
      if (this.isEditing) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: `Ya esta editando el compromiso ${this.commitment_index}. Guarde la edición para continuar.`,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      } else {
        this.isEditing = true;
      }
      this.$emit("refreshPerfomance", commitment, false);
      this.edit_performance = true;

      this.hours_committed_semester_1 = String(
        commitment.hours_committed_semester_1
      );
      this.hours_committed_semester_2 = String(
        commitment.hours_committed_semester_2
      );
      this.isWeekly = commitment.is_weekly_hours;
      this.selected_academic_activity =
        this.academicArea.academic_activities.find(
          (activity) => activity.id === commitment.academic_activity_id
        );
      this.observations = commitment.observations;
      this.semester = commitment.semester;
      this.commitmentId = commitment.id;
      this.commitment_index = commitment.commitment_index;
      this.selected_program_type = commitment.program_type;
      if (commitment.subject_code != null && commitment.subject_code !== "") {
        this.selected_subject = this.subjects.filter(
          (subject) => subject.codigo === parseInt(commitment.subject_code)
        )[0];
      } else {
        this.selected_subject = null;
      }
      this.is_edit = true;

      let element = document.getElementById("form-commitment");
      if (element) {
        await setTimeout(() => {}, 50);
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    handleSubjectSelection(selectedOption) {
      if (selectedOption && selectedOption.codigo === "OTROS") {
        // Si selecciona "Otros", cambiamos a mostrar todas las asignaturas
        this.showAllSubjects = true;
        this.selected_subject = null; // Resetear la selección
        this.selected_program_type = null; // Resetear la selección
      } else if (
        selectedOption &&
        selectedOption.codigo === "MIS_ASIGNATURAS"
      ) {
        // Si selecciona volver a "Mis asignaturas"
        this.showAllSubjects = false;
        this.selected_subject = null; // Resetear la selección
        this.selected_program_type = null; // Resetear la selección
      }
    },

    onManualHourChange(semester) {
      // Limpiar el mensaje automático
      this.autoMessage = "";
    },
    onManualTypeChange() {
      this.autoMessageProgramType = "";
    },
  },
  watch: {
    selected_subject(newValue) {
      if (this.edit_performance) {
        this.edit_performance = false;
        return;
      }
      // Ejecuta la lógica cada vez que cambie `selected_subject`
      this.disabled_docencia_comp = !(newValue != null && newValue !== "");
      this.selected_program_type = null;
      if (this.disabled_docencia_comp) {
        if (!this.need_subject) {
          this.disabled_docencia_comp = false;
        }
        this.hours_committed_semester_1 = null;
        this.hours_committed_semester_2 = null;
        this.isWeekly = true;
        this.observations = null;
      }
      if (newValue != null && newValue !== "" && newValue.tel) {
        const splitHours = newValue.tel.split("-");
        const hour_t = parseInt(splitHours[0]) || 0;
        const hour_e = parseInt(splitHours[1]) || 0;
        const hour_l = parseInt(splitHours[2]) || 0;
        //const totalHours = hour_t + hour_e + hour_l;
        //this.hours_committed_semester_1 = totalHours.toString();
        //this.hours_committed_semester_2 = totalHours.toString();
        if (this.selected_academic_activity) {
          if (
            this.selected_academic_activity.alt_name ===
            "Docencia directa frente alumnos (N° créditos T E)"
          ) {
            this.hours_committed_semester_1 = (hour_t + hour_e).toString();
            this.hours_committed_semester_2 = (hour_t + hour_e).toString();
            this.autoMessage =
              "(Autocompletado con TEL de la asignatura seleccionada)";
          } else if (
            this.selected_academic_activity.alt_name ===
            "Docencia Laboratorio directo (N° créditos L)"
          ) {
            this.hours_committed_semester_1 = hour_l.toString();
            this.hours_committed_semester_2 = hour_l.toString();
            this.autoMessage =
              "(Autocompletado con TEL de la asignatura seleccionada)";
          }
        }
      } else {
        // Si no hay TEL, limpiar el mensaje automático
        this.autoMessage = "";
      }
      if (newValue != null && newValue !== "" && newValue.tipo_programa) {
        this.selected_program_type = newValue.tipo_programa;
        this.autoMessageProgramType =
          "(Autocompletado con la información de la asignatura seleccionada)";
      }
    },
    selected_academic_activity(newValue) {
      this.disable_subject = !newValue;
      if (newValue != null && newValue !== "") {
        this.need_subject = !!newValue.requires_subject;
        this.need_program_type = !!newValue.requires_program_type;
      } else {
        this.need_subject = false;
        this.need_program_type = false;
      }

      if (this.need_subject) {
        if (!this.is_edit) {
          this.disabled_docencia_comp = true;
          this.selected_subject = null;
          this.selected_program_type = null;
          this.showAllSubjects = false; // Resetear vista de asignaturas
          this.hours_committed_semester_1 = null;
          this.hours_committed_semester_2 = null;
          this.isWeekly = true;
          this.observations = null;
        } else {
          this.is_edit = false;
        }
      } else {
        if (!this.is_edit) {
          this.disabled_docencia_comp = false;
          this.selected_subject = null;
          this.selected_program_type = null;
          this.showAllSubjects = false; // Resetear vista de asignaturas
          this.hours_committed_semester_1 = null;
          this.hours_committed_semester_2 = null;
          this.isWeekly = true;
        } else {
          this.is_edit = false;
        }
      }
    },
  },
  computed: {
    filteredSubjects() {
      // Retorna los primeros 5 elementos de la lista de opciones (subjects)
      return this.subjects.slice(0, 5);
    },
    mySubjectsWithOthers() {
      // Agregar opción "Otros" al final de las asignaturas del académico
      const othersOption = {
        codigo: "OTROS",
        codigo_nombre: "Otros - Ver todas las asignaturas",
      };
      return [...this.mySubjects, othersOption];
    },
    subjectsWithOthers() {
      // Para el listado completo, incluir opción para volver a "Mis asignaturas"
      const backOption = {
        codigo: "MIS_ASIGNATURAS",
        codigo_nombre: "Volver a mis asignaturas",
      };
      return [backOption, ...this.subjects];
    },
  },
};
</script>

<style scoped>
.inline-label-tooltip {
  display: flex;
  align-items: center;
}

.inline-label-tooltip .label-container {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem; /* Espaciado entre el label y el b-input */
}

.inline-label-tooltip .label-container .control {
  margin-left: 0.5rem; /* Espaciado entre el label y el tooltip */
}

.preserve-line-breaks {
  white-space: pre-wrap;
}
</style>
